import React, { useState } from "react";
import Navbar from "../../../components/navbar/navbar";
import TitleSection from "../../../components/title-section/title-section";
import Footer from "../../../components/footer/Footer";
import "./aeromexico-cargo.css";
import { useTranslation } from "react-i18next";
import ScrollToTop from "../../../components/scrollToTop/scrollToTop";
import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";
import Helmet from "react-helmet";
import Information from "../../home-amc/information/information";
import BreadCrumb from "../../../components/breadcrumb/breadcrumb";
import imgBg from "../../../assets/imgs/about-us/bg-nosotros.png";
import { FaAngleLeft, FaAngleRight, FaAngleDown } from "react-icons/fa6";
import pinkLines from "../../../assets/imgs/track/lines.svg";

function AeromexicoCargo() {
  const [tAeroMexicoCargo] = useTranslation("aboutUs");
  const [tSMetaData] = useTranslation("metaData");
  const [showMore, setShowMore] = useState(false);

  const [selectedYear, setSelectedYear] = useState(1989);

  const handleYearClick = (year) => {
    setSelectedYear(year);
  };

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"]["about-us"]}/${
      Object.keys(navBarEs["about-us"])[0]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"]["about-us"]}/${
      Object.keys(navBarEn["about-us"])[0]
    }`
  );

  const contentByYear = {
    1989: {
      title: tAeroMexicoCargo("1989.title"),
      text: tAeroMexicoCargo("1989.text"),
      imageClass: "bg-1989",
    },
    1990: {
      title: tAeroMexicoCargo("1990.title"),
      text: tAeroMexicoCargo("1990.text"),
      imageClass: "bg-1990",
    },
    1992: {
      title: tAeroMexicoCargo("1992.title"),
      text: tAeroMexicoCargo("1992.text"),
      imageClass: "bg-1992",
    },
    1994: {
      title: tAeroMexicoCargo("1994.title"),
      text: tAeroMexicoCargo("1994.text"),
      imageClass: "bg-1994",
    },
    1998: {
      title: tAeroMexicoCargo("1998.title"),
      text: tAeroMexicoCargo("1998.text"),
      imageClass: "bg-1998",
    },
    2005: {
      title: tAeroMexicoCargo("2005.title"),
      text: tAeroMexicoCargo("2005.text"),
      imageClass: "bg-2005",
    },
    2007: {
      title: tAeroMexicoCargo("2007.title"),
      text: tAeroMexicoCargo("2007.text"),
      imageClass: "bg-2007",
    },
    2012: {
      title: tAeroMexicoCargo("2012.title"),
      text: tAeroMexicoCargo("2012.text"),
      imageClass: "bg-2012",
    },
  };

  const currentContent = selectedYear ? contentByYear[selectedYear] : null;

  return (
    <>
      <Helmet>
        <title>{tSMetaData("nosotros.title")}</title>
        <meta name="description" content={tSMetaData("nosotros.description")} />
      </Helmet>
      <ScrollToTop />
      <Information />
      <Navbar />
      <BreadCrumb />
      <TitleSection title={tAeroMexicoCargo("title.title-page")} />
      
      
      <div className="our-container-img">
        <div className="bg-opacity"></div>
        <img src={imgBg} alt="Aeromexico Cargo" />
        <button className="arrow-left arrow"><FaAngleLeft /></button>
        <button className="arrow-right arrow"><FaAngleRight /></button>

        <div className="info-text">
          <h3>2020</h3>
          <h5>Aeroméxico</h5>
          <p>Instrumentación del Modelo de Vuelos Chárter (COVID-19)</p>
        </div>

        <div className="checkpoint-content">
          <div className="checkpoint">
            <div className="line-pink"></div>
            <div className="line"></div>

            <div className="item-content">
              <div className="circle pink"></div>
              <p className="text">2019</p>
            </div>

            <div className="item-content">
              <div className="circle pink"></div>
              <p className="text">2020</p>
            </div>

            <div className="item-content">
              <div className="circle"></div>
              <p className="text">2021</p>
            </div>

            <div className="item-content">
              <div className="circle"></div>
              <p className="text">2022</p>
            </div>

            <div className="item-content">
              <div className="circle"></div>
              <p className="text">2023</p>
            </div>

            <div className="item-content">
              <div className="circle"></div>
              <p className="text">2024</p>
            </div>

            <div className="item-content">
              <div className="circle"></div>
              <p className="text">2025</p>
            </div>

            <div className="item-content">
              <div className="circle"></div>
              <p className="text">2026</p>
            </div>
          </div>
        </div>
      </div>

      <div className="amc-out-title">
        <h4>Instrumentación del Modelo de Vuelos Chárter (COVID-19)</h4>
        <img src={pinkLines} />
      </div>

      <div className={!showMore ? "amc-our-information" : "amc-our-information collapsed"}>
        <ul className="principal-text">
          <li>Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.</li>

          <li>Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.</li>

          <div className={!showMore ? "more-content" : "more-content collapsed"}>
            <p>Aeroméxico y Mexicana crean la empresa Aeromexpress S.A. de C.V., donde se concentraría la actividad de carga de ambas aerolíneas.</p>

            <p>Se constituye Aeromexpress SA de CV como la primer Línea Aérea Carguera en México, logrando obtener de IATA la autorización bajo el código QO y el prefijo 976.</p>
          </div>

        </ul>
        <button className="show-more" onClick={() => setShowMore(!showMore)}>
          LEER MÁS <div className={showMore ? "icon rotate-180" : "icon"}><FaAngleDown /></div>
        </button>
      </div>

      {/* <div className="container-fluid px-0">
        <div className="row m-0 d-flex">
          <div className="col-3 col-xl-2 order-2 align-self-center text-center fs-2">
            <ul className="li-none m-0 p-0 py-4">
              <li
                onClick={() => handleYearClick(1989)}
                className={
                  selectedYear === 1989 ? "selected-year" : "text-clear-gray"
                }
              >
                1989
              </li>
              <li
                onClick={() => handleYearClick(1990)}
                className={
                  selectedYear === 1990 ? "selected-year" : "text-clear-gray"
                }
              >
                1990
              </li>
              <li
                onClick={() => handleYearClick(1992)}
                className={
                  selectedYear === 1992 ? "selected-year" : "text-clear-gray"
                }
              >
                1992
              </li>
              <li
                onClick={() => handleYearClick(1994)}
                className={
                  selectedYear === 1994 ? "selected-year" : "text-clear-gray"
                }
              >
                1994
              </li>
              <li
                onClick={() => handleYearClick(1998)}
                className={
                  selectedYear === 1998 ? "selected-year" : "text-clear-gray"
                }
              >
                1998
              </li>
              <li
                onClick={() => handleYearClick(2005)}
                className={
                  selectedYear === 2005 ? "selected-year" : "text-clear-gray"
                }
              >
                2005
              </li>
              <li
                onClick={() => handleYearClick(2007)}
                className={
                  selectedYear === 2007 ? "selected-year" : "text-clear-gray"
                }
              >
                2007
              </li>
              <li
                onClick={() => handleYearClick(2012)}
                className={
                  selectedYear === 2012 ? "selected-year" : "text-clear-gray"
                }
              >
                2012
              </li>
            </ul>
          </div>
          <div className="col-9 px-4 my-4 col-xl-4 align-self-center order-3">
            {currentContent && (
              <>
                <p className="text-gray fs-16">{selectedYear}</p>
                <p className="text-premium-blue fs-3">{currentContent.title}</p>
                <p className="text-gray fs-14">{currentContent.text}</p>
              </>
            )}
          </div>
          <div className="col-12 col-xl-6 order-1 order-xl-3 p-0">
            {currentContent && (
              <div
                className={`bg-container ${currentContent.imageClass}`}
              ></div>
            )}
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
}

export default AeromexicoCargo;
